import { ContentFactory } from './entity/contentFactory';

import type { NoticeCategoryIRepository } from './entity/noticeCategoryIRepository';
import type { NoticeItemIRepository } from './entity/noticeItemIRepository';
import type { Logger } from '@/infra/logger';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { ContentJson } from '@/types/domain/notice/entities/contentEntity';

import { DomainServiceBase } from '@/domain/domainServiceBase';

export class NoticeDomainService extends DomainServiceBase {
  private wagakoNurseryApi!: WagakoNurseryIApi;

  private noticeCategoryRepository!: NoticeCategoryIRepository;

  private noticeItemRepository!: NoticeItemIRepository;

  private contentFactory = new ContentFactory();

  /**
   * Inject
   * @param wagakoNurseryApi wagakoNurseryApi
   * @param noticeCategoryRepository noticeCategoryRepository
   * @param noticeItemRepository noticeItemRepository
   */
  public constructor(
    wagakoNurseryApi: WagakoNurseryIApi,
    noticeCategoryRepository: NoticeCategoryIRepository,
    noticeItemRepository: NoticeItemIRepository,
    logger: Logger,
  ) {
    super(logger);
    this.wagakoNurseryApi = wagakoNurseryApi;
    this.noticeCategoryRepository = noticeCategoryRepository;
    this.noticeItemRepository = noticeItemRepository;
  }

  /**
   * カテゴリ一覧を取得する.
   * @param nurseryId nurseryId.
   */
  public async getCategoryList(nurseryId: string) {
    const result = await this.noticeCategoryRepository.getPublicAllList(nurseryId);
    return result;
  }

  /**
   * アイテム一覧を取得する.
   * @param nurseryId nurseryId.
   * @param token token.
   */
  public async getNoticeItemList(nurseryId: string, categoryId: string, token: string | null) {
    const result = await this.noticeItemRepository.getPublicListWithKey(
      nurseryId,
      categoryId,
      token,
    );
    return result;
  }

  /**
   * コンテンツをロードする.
   * @param s3Path s3Path.
   * @param nurseryId nurseryId.
   */
  public async loadContent(
    s3Path: string,
    nurseryId: string,
  ) {
    const result = await this.wagakoNurseryApi.loadFileFromS3(s3Path, nurseryId);
    const text = this.wagakoNurseryApi.gunzipText(result.data);
    const json = JSON.parse(text) as ContentJson;
    // 一度entityに入れて情報を補完する（不要かも）
    const ent = this.contentFactory.createFromJsonPvt(json);
    return ent.toJsonData();
  }
}
